// extracted by mini-css-extract-plugin
export default {"jumbotron":"Jumbotron_jumbotron__S6K3U"};